import { get, isEmpty } from 'lodash';
import { setExperimentsBucket } from '@sparefoot/react-core/modules/experiments';
import { logExperimentBucketing } from 'utils/experimentUtils';

export default (store) => (next) => (action) => {
	const { user } = store.getState();
	const experiments = get(action, 'payload.experiments');
	if (!isEmpty(experiments) && user.visitId !== 'SELENIUM') {
		store.dispatch(setExperimentsBucket(experiments));
		logExperimentBucketing(experiments?.bucket);
	}
	return next(action);
};
